import React from 'react';
import PropTypes from 'prop-types';

import { StyledSvgIcon } from './styles';
import VpIcon from '../VpIcon/VpIcon';

export const VpIconButton = ({ icon = '', isSquare = false, ...rest }) => {
  return (
    <StyledSvgIcon {...rest} isSquare={isSquare}>
      <VpIcon icon={icon} />
    </StyledSvgIcon>
  );
};

VpIconButton.propTypes = {
  icon: PropTypes.string.isRequired,
  isSquare: PropTypes.bool
};

export default VpIconButton;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpIconButton/VpIconButton.jsx